import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/marketing`;

export const mktApi = {
  // 客先マスタ
  customers: (params) => axios.get(`${API}/customers`, { params }).then((r) => r.data),
  createCustomer: (b) => axios.post(`${API}/customers`, b).then((r) => r.data),
  updateCustomer: (id, b) => axios.put(`${API}/customers/${id}`, b).then((r) => r.data),
  deleteCustomer: (id) => axios.delete(`${API}/customers/${id}`).then((r) => r.data),
  // 受注
  orders: (params) => axios.get(`${API}/orders`, { params }).then((r) => r.data),
  order: (id) => axios.get(`${API}/orders/${id}`).then((r) => r.data),
  createOrder: (b) => axios.post(`${API}/orders`, b).then((r) => r.data),
  updateOrder: (id, b) => axios.put(`${API}/orders/${id}`, b).then((r) => r.data),
  deleteOrder: (id) => axios.delete(`${API}/orders/${id}`).then((r) => r.data),
  stockCheck: (id) => axios.post(`${API}/orders/${id}/stock-check`).then((r) => r.data),
  estimate: (id, b) => axios.post(`${API}/orders/${id}/estimate`, b).then((r) => r.data),
  internalApproval: (id, b) => axios.post(`${API}/orders/${id}/internal-approval`, b).then((r) => r.data),
  issueDocument: (id, doc_type) => axios.post(`${API}/orders/${id}/documents`, { doc_type }).then((r) => r.data),
  documents: (id) => axios.get(`${API}/orders/${id}/documents`).then((r) => r.data),
  document: (docId) => axios.get(`${API}/documents/${docId}`).then((r) => r.data),
  present: (id) => axios.post(`${API}/orders/${id}/present`).then((r) => r.data),
  approval: (id, b) => axios.post(`${API}/orders/${id}/approval`, b).then((r) => r.data),
  requote: (id) => axios.post(`${API}/orders/${id}/requote`).then((r) => r.data),
  cancel: (id, reason) => axios.post(`${API}/orders/${id}/cancel`, { reason }).then((r) => r.data),
  // Seizoパイプライン (Phase 2)
  sendToSeizo: (id, b) => axios.post(`${API}/orders/${id}/send-to-seizo`, b).then((r) => r.data),
  rehandoffLine: (id, line_id) => axios.post(`${API}/orders/${id}/rehandoff-line`, { line_id }).then((r) => r.data),
  qc: (id, b) => axios.post(`${API}/orders/${id}/qc`, b).then((r) => r.data),
  ready: (id) => axios.post(`${API}/orders/${id}/ready`).then((r) => r.data),
  ship: (id, b) => axios.post(`${API}/orders/${id}/ship`, b).then((r) => r.data),
  kansei: (id, b) => axios.post(`${API}/orders/${id}/kansei`, b).then((r) => r.data),
  reopen: (id) => axios.post(`${API}/orders/${id}/reopen`).then((r) => r.data),
  shippingQueue: (params) => axios.get(`${API}/shipping/queue`, { params }).then((r) => r.data),
  dashboard: () => axios.get(`${API}/dashboard`).then((r) => r.data),
  // ファイル (証憑)
  uploadFile: (file) => { const fd = new FormData(); fd.append('file', file); return axios.post(`${API}/files`, fd).then((r) => r.data); },
  fileUrl: (id) => `${API}/files/${id}`,
  // 販売単価マスタ
  priceList: (customer_id) => axios.get(`${API}/price-list`, { params: { customer_id } }).then((r) => r.data),
  createPrice: (b) => axios.post(`${API}/price-list`, b).then((r) => r.data),
  updatePrice: (id, b) => axios.put(`${API}/price-list/${id}`, b).then((r) => r.data),
  deletePrice: (id) => axios.delete(`${API}/price-list/${id}`).then((r) => r.data),
  importPrices: (customer_id, file) => { const fd = new FormData(); fd.append('customer_id', customer_id); fd.append('file', file); return axios.post(`${API}/price-list/import`, fd).then((r) => r.data); },
  // 締め請求
  billing: (month) => axios.get(`${API}/billing`, { params: { month } }).then((r) => r.data),
  billingIssue: (b) => axios.post(`${API}/billing/issue`, b).then((r) => r.data),
  billingCsvUrl: (month) => `${API}/billing/csv?month=${month}`,
  billingUnpaid: () => axios.get(`${API}/billing/unpaid`).then((r) => r.data),
  billingPay: (b) => axios.post(`${API}/billing/payment`, b).then((r) => r.data),
  billingUnpay: (docId) => axios.delete(`${API}/billing/payment/${docId}`).then((r) => r.data),
  // 設定
  settings: () => axios.get(`${API}/settings`).then((r) => r.data),
  saveSettings: (b) => axios.put(`${API}/settings`, b).then((r) => r.data),
  uploadLogo: (file) => { const fd = new FormData(); fd.append('file', file); return axios.post(`${API}/settings/logo`, fd).then((r) => r.data); },
  deleteLogo: () => axios.delete(`${API}/settings/logo`).then((r) => r.data),
  logoUrl: `${API}/settings/logo`,
  uploadSeal: (file) => { const fd = new FormData(); fd.append('file', file); return axios.post(`${API}/settings/seal`, fd).then((r) => r.data); },
  deleteSeal: () => axios.delete(`${API}/settings/seal`).then((r) => r.data),
  sealUrl: `${API}/settings/seal`,
  // デモモード
  demoStatus: () => axios.get(`${API}/demo/status`).then((r) => r.data),
  demoSeed: () => axios.post(`${API}/demo/seed`, {}, { timeout: 180000 }).then((r) => r.data),
  demoWipe: () => axios.post(`${API}/demo/wipe`).then((r) => r.data),
  demoEnd: () => axios.post(`${API}/demo/end`, {}, { timeout: 180000 }).then((r) => r.data),
  demoOnboarding: () => axios.get(`${API}/demo/onboarding`).then((r) => r.data),
  demoOnboardingAck: (action) => axios.post(`${API}/demo/onboarding-ack`, { action }).then((r) => r.data),
};

export const errMsg = (e, fallback = '操作に失敗しました') => e?.response?.data?.detail || fallback;
